import axios from 'axios';
import config from '../appconfig/config.json';
import storage from '../factory/StorageFactory';

let baseApiUrl = config.SmeApi.DEV;
 
switch (config.SERVER_STATUS) {
  case "DEV": baseApiUrl = config.SmeApi.DEV
    break;
  case "SIT": baseApiUrl = config.SmeApi.SIT 
    break;
  case "UAT": baseApiUrl = config.SmeApi.UAT 
    break;
  case "PROD": baseApiUrl = config.SmeApi.PROD 
    break;
  case "SIM": baseApiUrl = config.SmeApi.SIM 
    break;
  default:
    break;
}

export default axios.create({
    baseURL: baseApiUrl,
    headers: {
      "Content-type": "application/json",
      'Authorization': "Maybank" + " " + storage.getToken()
    }
});



//Api: http://10.4.93.88:8080/SMEApplication/api/v1/SME
//dummy:  http://localhost:3000/db.json